import { useEffect } from 'react';
import Swal from 'sweetalert2';

const DeleteConfirmation = ({ isOpen, onClose, onConfirm, itemName, itemType, loading = false }) => {
  useEffect(() => {
    if (isOpen) {
      Swal.fire({
        title: 'Are you sure?',
        text: itemName ? `Delete ${itemName}?` : `Delete this ${itemType}?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#dc2626',
        cancelButtonColor: '#6b7280',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        reverseButtons: true,
        allowOutsideClick: !loading,
        allowEscapeKey: !loading,
        showLoaderOnConfirm: true,
        width: '350px',
        padding: '20px',
        customClass: {
          popup: 'small-alert',
          title: 'small-alert-title',
          htmlContainer: 'small-alert-text',
          actions: 'small-alert-actions',
          confirmButton: 'small-alert-btn',
          cancelButton: 'small-alert-btn'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          onConfirm();
        } else {
          onClose();
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, itemName, itemType]);

  return null; // SweetAlert2 renders its own modal
};

export default DeleteConfirmation;
